import * as React from "react";
import { Icon as IconCore, IIconProps as IIconPropsCore } from "@webbio/components";

const Icon = (props: IIconPropsCore): JSX.Element => {
  return <IconCore {...props} />;
};

export { Icon };
